import type { AllRouteEndpoints } from "../routeTypes";
export const engagementContentBlocksUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/content_blocks",
  "/engagement/content_blocks/:id",
];
